<template>
    <page>
        <module enable-flex>
          <m-search ref="search" @search="searchHandle">
            <m-search-item label="用户昵称">
              <c-input name="nick_name"></c-input>
            </m-search-item>
            <m-search-item label="用户手机号">
              <c-input name="user_manage_mobilephone"></c-input>
            </m-search-item>
            <m-search-item label="订单号">
              <c-input name="order_number" placeholder="模糊订单号"></c-input>
            </m-search-item>
            <m-search-item label="下单服务">
                <c-input name="product_name" placeholder="模糊匹配下服务名称、规格"></c-input>
            </m-search-item>
            <m-search-item label="评价时间" colspan="2">
              <c-datetime start-name="start_date" end-name="end_date" range></c-datetime>
            </m-search-item>
            <m-search-item label="订单服务类型" colspan="2">
              <c-checkbox-group name="state" :options="stateType"></c-checkbox-group>
            </m-search-item>
            <m-search-item label="是否有图/视频">
              <c-checkbox-group name="is_media" :options="[{name: '有图/视频',value: 1}]"></c-checkbox-group>
            </m-search-item>
          </m-search>

          <c-table ref="table" code="order_evaluate_list">
                <c-table-column
                        type="selector"
                ></c-table-column>

                <c-table-column
                        label="状态"
                        name="start_state"
                        width="60"
                >
                    <template v-slot="{data}">
                        <span v-if="data.state == 2" style="color:green">{{stateText[data.state]}}</span>
                        <span v-if="data.state == 1" style="color:red">{{stateText[data.state]}}</span>
                    </template>
                </c-table-column>

                <c-table-column label="用户头像/昵称" name="share_user_nick_name" width="120">
                    <template v-slot="{data}">
                        <div class="flex-center-cross">
                            <c-file  :src="data.head_photo"  class="image_head_photo" media></c-file>
                            <span>{{ data.nick_name || '--' }}</span>
                        </div>
                    </template>
                </c-table-column>

                <c-table-column
                        label="用户手机号"
                        name="user_manage_mobilephone"
                        width="120"
                ></c-table-column>

                <c-table-column
                        label="订单号"
                        name="order_number"
                        width="120"
                ></c-table-column>

                <c-table-column
                        label="下单服务"
                        name="product_name"
                        width="350"
                >
                    <template v-slot="{data}">
                        <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_name + ' - '+data.product_sku_spec"></product-info>
                        <product-info v-else :image="data.product_img_url" :name="data.product_name + ' - '+data.product_sku_spec"></product-info>
                    </template>
                </c-table-column>

                <c-table-column
                        label="评分"
                        name="score"
                        width="50"
                ></c-table-column>

                <c-table-column
                        label="查看数量"
                        name="view_count"
                        width="80"
                ></c-table-column>

                <c-table-column
                        label="点赞数量"
                        name="thumb_count"
                        width="80"
                ></c-table-column>

                <c-table-column
                        label="评价内容"
                        name="evaluate_comment"
                        width="180"
                ></c-table-column>

                <c-table-column
                        label="图片/视频"
                        width="170"
                >
                    <template v-slot="{data}">
                        <div class="img-list flex-wrap" v-if="data.file_urls">
                            <div v-for="(item, j) in (data.file_urls.split(','))" :key="j" style="margin-right: 5px;">
                                <c-file class="image_list" :src="item" size="25" media></c-file>
                            </div>
                        </div>

                    </template>
                </c-table-column>

                <c-table-column
                        label="评价时间"
                        name="create_date"
                        width="145"
                ></c-table-column>


                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
						width="160"
                >
                    <template v-slot="{data}">
                        <c-table-button @click="navigateTo(`/order_evaluate_detail/${data.id}`)">查看</c-table-button>
                        <c-table-button power="b_order_evaluate_state" v-if="data.state == 2" @click="disableActivity(data,1)">禁用</c-table-button>
                        <c-table-button power="b_order_evaluate_state" v-if="data.state == 1" @click="disableActivity(data,2)">启用</c-table-button>
                        <c-table-button  @click="del(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>
    </page>
</template>

<script>
    import productInfo from "@/components/public/product_info.vue";

    export default {
        name: 'm_order_evaluate',
        components: {productInfo},

        computed: {
            stateText() {
                var state = {};
                this.stateType.forEach(item => {
                    state[item.value] = item.name;
                });

                return state;
            }
        },

        data() {
            return {

                stateType: [{
                    name: '禁用',
                    value: 1
                },{
                    name: '启用',
                    value: 2
                }
                ]
            }
        },

        mounted() {
            this.$refs.search.search();


        },

        methods: {
            searchHandle(data) {
                this.$refs.table.load({
                    url: '/orderEvaluate/list',
                    data
                });
            },

            disableActivity(item,state) {
              this.$confirm({
                    title: '请确认',
                    message: state == 2 ? '确定要启用此评价吗？' : '确定要禁用此评价吗',
                    resolve: () => {
                        this.request({
                            url: '/orderEvaluate/updateState',
                            data: {
                                id: item.id,
                                state: state
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                  type:'success',
                                  message: state == 2 ? '启用成功' :'禁用成功'
                                });
                                this.$refs.table.update();
                            }
                        });
                    }
                });
            },

            del(val) {
                this.$confirm({
                    title: '请确认',
                    message: '确定要删除此评价吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/orderEvaluate/remove',
                            data: {type:1,id:val.id},
                            loading: true,
                            success: data => {
                                this.$message({
                                    type: 'success',
                                    message: '操作成功',
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },
        }
    }
</script>
<style lang="stylus" scoped>
.image_head_photo{
  width: 30px;
  height: 30px;
  background: rgb(245, 245, 245);
  margin-right: 10px;
}
.image_list{
  width: 45px;
  height: 45px;
  background: rgb(245, 245, 245);
}
</style>